// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3FPZV","requiredAsterisk":"Info_requiredAsterisk__X1hRT"};